<div class="file-manager-container">
  <div class="image-grid">
    @for (file of imageFiles; track file) {
      <div
        class="image-card"
        [class.selected]="selectedImages.has(file)"
        [class.invalid]="isMultiSelect && isSequenceInvalid(file)"
        (click)="toggleSelection(file)"
        >
        <img [src]="baseUrl + '/' + accessionIdentifier + '/' + file" [alt]="file">
        <div class="filename">{{ file }}</div>
        @if (isMultiSelect && selectedImages.has(file)) {
          <div class="sequence-input">
            <label>Sequence:</label>
            <input
              type="number"
              min="1"
              [value]="sequenceMap[file]"
              (click)="$event.stopPropagation()"
              (change)="onSequenceChange(file, $event.target.value)"
              >
          </div>
        }
      </div>
    }
  </div>

  <div class="actions">
    <button class="primary-btn" (click)="onSubmit()" [disabled]="selectedImages.size === 0 || (isMultiSelect && hasInvalidSequence()) ">Submit</button>
  </div>
</div>